module.exports = __webpack_public_path__ + "img/azure-ad-pim.a7f3ead4.svg";